<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onGoToEdit()">
        <mat-icon>edit</mat-icon>
        {{ 'common.go_to_edit' | translate }}
    </button>
    <ng-content></ng-content>
</div>
